<div id="additional-info-view" role="main">
  <mat-card id="additional-info-view-container">
    <mat-card-content [innerHTML]="sanitizedHtml">
    </mat-card-content>
  </mat-card>
</div>
